module.exports = __webpack_public_path__ + "media/images/icons/paycards-35113abb6a4b0985bfee32f505c1854a.png";